// @flow

import * as React from 'react'

type Props = {
  color?: string,
}

export const IconInfo = ({ color }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill={color}
    >
      <path d="M8.5 0C3.8131 0 0 3.81315 0 8.50005C0 13.187 3.8131 17 8.5 17C13.1869 17 17 13.187 17 8.50005C17 3.81315 13.1869 0 8.5 0ZM8.5 15.4545C4.66521 15.4545 1.54545 12.3348 1.54545 8.50005C1.54545 4.66532 4.66521 1.54545 8.5 1.54545C12.3348 1.54545 15.4545 4.66532 15.4545 8.50005C15.4545 12.3348 12.3347 15.4545 8.5 15.4545Z" />
      <path d="M8.49885 3.60596C7.93084 3.60596 7.46875 4.06836 7.46875 4.63672C7.46875 5.20458 7.93084 5.66656 8.49885 5.66656C9.06685 5.66656 9.52894 5.20458 9.52894 4.63672C9.52894 4.06836 9.06685 3.60596 8.49885 3.60596Z" />
      <path d="M8.50027 7.21216C8.07351 7.21216 7.72754 7.55813 7.72754 7.98489V12.6212C7.72754 13.048 8.07351 13.394 8.50027 13.394C8.92702 13.394 9.27299 13.048 9.27299 12.6212V7.98489C9.27299 7.55813 8.92702 7.21216 8.50027 7.21216Z" />
    </svg>
  )
}
